import PropTypes from 'prop-types'
import React from 'react'
import { List } from 'immutable'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import CartProgressIndicator from '../../CartProgressIndicator/index'
import { connect as connectPage, PAGE_SEO_TYPE_LOCATION } from '../../Page/connect'
import { connect as connectStaticText } from '../../StaticText/connect'
import {
  URL_CART_BILLING_PAYMENT,
} from '../../../services/url/constants'
import { DATA_ACTION_CONTINUE } from '../../Link/constants'
import Button, { TYPES } from '../../Button/index'
import { H1, HEADING_TYPES } from '../../Heading/index'
import {
  getCurrentTime,
  getFormattedLocaleDate,
  addDays,
  formatDateWithTimezonOffset,
} from '../../../services/date-time/index'
import { getPrimary } from '../../../services/languages/index'
import {
  getFreeTrialPeriod,
} from '../../../services/plans/index'
import CartOrderSummaryV2 from '../CartOrderSummaryV2/index'
import CartLayoutTemplate from '../CartLayoutTemplate/index'

function getTrialPeriodExplaination (text = '', period) {
  return String(text).replace(/\$\{ trialDuration \}/g, period)
}

function CartChoosePaymentPageV2 (props) {
  const {
    staticText,
    plans,
    user,
  } = props

  const planFreeTrialPeriod = getFreeTrialPeriod(plans.getIn(['selection', 'segments'], List()))
  const formattedDate = new Date(addDays(getCurrentTime(), planFreeTrialPeriod))
  const userLanguage = getPrimary(user.getIn(['data', 'language']))
  const expireDate = getFormattedLocaleDate(
    formatDateWithTimezonOffset(formattedDate),
    userLanguage,
  )

  return (
    <div className="cart-choose-payment-v2">
      <CartLayoutTemplate
        colOne={
          <React.Fragment>
            <CartProgressIndicator v2 />
            <H1 as={HEADING_TYPES.H3} className="cart-choose-payment-v2__title">
              {staticText.getIn(['data', 'setUpPayment'])}
            </H1>
            <div className="cart-choose-payment-v2__description-container">
              {
                planFreeTrialPeriod
                  ? <p className="cart-choose-payment-v2__description">
                      {`${getTrialPeriodExplaination(staticText.getIn(['data', 'trialExplaination']), planFreeTrialPeriod)} ${expireDate}.`}
                    </p>
                  : <p className="cart-choose-payment-v2__description">
                      {staticText.getIn(['data', 'nonTrialExplanation'])}
                    </p>
              }
            </div>
            <div className="cart-choose-payment-v2__button-container">
              <Button
                url={URL_CART_BILLING_PAYMENT}
                type={TYPES.PRIMARY}
                className="cart-choose-payment-v2__button"
                data-action={DATA_ACTION_CONTINUE}
              >
                {staticText.getIn(['data', 'almostDone'])}
              </Button>
            </div>
          </React.Fragment>
        }
        colTwo={
          <div className="cart-choose-payment-v2__order-summary">
            <CartOrderSummaryV2 />
          </div>
        }
      />
    </div>
  )
}

CartChoosePaymentPageV2.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  checkout: ImmutablePropTypes.map.isRequired,
  plans: ImmutablePropTypes.map.isRequired,
  user: ImmutablePropTypes.map.isRequired,
  userAccount: ImmutablePropTypes.map.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
}

export default compose(
  connectPage({ seoType: PAGE_SEO_TYPE_LOCATION }),
  connectRedux(
    (state) => ({
      auth: state.auth,
      checkout: state.checkout,
      plans: state.plans,
      user: state.user,
      userAccount: state.userAccount,
    }),
  ),
  connectStaticText({ storeKey: 'cartChoosePaymentPageV2' }),
)(CartChoosePaymentPageV2)
